/* LP-Hero carousel: scroll-snap slider met pijlen + dots (alleen bij >1 afbeelding) */
(function () {
  function init(media) {
    if (media.dataset.lpCarousel === '1') return;
    var track = media.querySelector('.lp-hero__track');
    if (!track) return;
    var imgs = track.querySelectorAll('.lp-hero__img');
    if (imgs.length < 2) return;
    media.dataset.lpCarousel = '1';

    var dots = media.querySelectorAll('.lp-hero__dot');
    var prev = media.querySelector('.lp-hero__arw--prev');
    var next = media.querySelector('.lp-hero__arw--next');

    function index() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function go(i) {
      i = Math.max(0, Math.min(imgs.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var cur = index();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === cur);
        });
      });
    }, { passive: true });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.lp-hero__media--carousel').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  /* Shopify theme-editor: opnieuw initialiseren na herladen van de sectie */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
